// Modules/Guide/Guide.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiService from '../../Utils/APIService';
import { useBrand } from '../../Utils/BrandContext';


const Guide = () => {
  const { brand, updateBrand } = useBrand();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  // Fetch lead data
  const fetchLeadData = async (mobile, o) => {
    try {
      const leadResponse = await apiService.getLeadInfo(mobile, o);

      if (leadResponse?.d?.error === false) {
        const updatePackage = JSON.parse(leadResponse.d.updatePackage);
        const leadInfo = updatePackage.info ? JSON.parse(updatePackage.info) : [];
        const leadO = leadInfo[0]?.LeadO || o || '';

        return {
          success: true,
          leadData: updatePackage,
          leadO: leadO,
          mobile: mobile
        };
      } else {
        throw new Error('Failed to fetch lead data');
      }
    } catch (err) {
      console.error('Fetch lead data error:', err);
      throw err;
    }
  };

  const getRedirectPath = (zParam, mobile, o, m, brand) => {
    const activeBrand = brand || m || 'qikerp';
    const mQuery = `&m=${activeBrand}`;

    const baseUrl = window.location.hostname === 'localhost' ? `http://localhost:${window.location.port}/QikERP` : `${apiService.getBaseUrl()}/QikERP`;

    switch (zParam?.toLowerCase()) {
      case 'intro':
        return `${baseUrl}/Intro?i=${mobile}&o=${o}${mQuery}`;
      case 'offer':
        return `${baseUrl}/GPower?i=${mobile}&o=${o}${mQuery}&scroll=pricing`;
      case 'question':
        return `https://biziverse.com/Question.html?i=${mobile}&o=${o}`;
      case 'feedback':
        case 'fdbk':
            return `${baseUrl}/FeedBack?i=${mobile}&o=${o}${mQuery}`;
      case 'demo':
        return `${baseUrl}/Demo?i=${mobile}&o=${o}${mQuery}`;
      case 'main':
      default:
        return `${baseUrl}/GPower?i=${mobile}&o=${o}${mQuery}`;
    }
  };

  useEffect(() => {
    const fetchAndRedirect = async () => {
      const i = searchParams.get('i'); // mobile
      const o = searchParams.get('o') || ''; // leadid
      const z = searchParams.get('z'); // redirect option
      const m = searchParams.get('m') || ''; // brand option

      if (m) updateBrand(m);

      if (!i) {
        console.error('Missing mobile parameter');
        window.location.href = '/';
        return;
      }

      try {
        // Fetch lead data
        const result = await fetchLeadData(i, o);

        if (result.success) {
          // IMPORTANT: Set initial data needed by BZPay
          localStorage.setItem('allData', JSON.stringify(result.leadData));
          localStorage.setItem('mySrc', result.leadData.source || 'Guide');

          const cioData = [{
            'i': result.mobile,
            'o': result.leadO,
            'cmp': result.leadData.companyName,
            'name': result.leadData.firstName + ' ' + result.leadData.lastName,
            'eml': result.leadData.email
          }];
          localStorage.setItem('cio', JSON.stringify(cioData));

          const redirectPath = getRedirectPath(z, result.mobile, result.leadO, m, brand || m || 'qik');
          window.location.href = redirectPath;
        } else {
          setError('Failed to load data');
        }
      } catch (err) {
        console.error('Error in Guide:', err);
        setError('Something went wrong');
        // Fallback redirect to main page
        setTimeout(() => {
          const mQuery = m ? `&m=${m}` : '';
          window.location.href = `https://biziverse.com/QikERP/GPower?i=${i}&o=${o || ''}`;
        }, 2000);
      }
    };

    fetchAndRedirect();
  }, [searchParams, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">

      </div>
    </div>
  );
};

export default Guide;